import React, { useEffect, useMemo, useState } from "react";
import { getPropsDataGrid } from "../../../utils/default-props";
import { getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { useNavigate } from "react-router-dom";
import { Button, DataGrid } from "devextreme-react";
import { Column, Editing, Toolbar, Item, RequiredRule,Lookup } from "devextreme-react/data-grid";
import { usePublicEvents } from "../../../contexts/public-events";
import { useAuth } from "../../../contexts/auth";
import LoaderPage from "../../../layouts/loader-page/loader-page";
import { useDataSource } from "../../../contexts/dataSource";

function OvertimeList() {
    const loading = false;
    const navigate = useNavigate();
    const { setPublicAddEvent } = usePublicEvents() || {};
    const { user } = useAuth() || {};
    const { dataSourceHR } = useDataSource()

    const dbEmployes = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw",

    }), [user])


    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeOvertime`,
        insertUrl: "/api/EmployeeOvertime"
    }), [user])

    const handleRowDblClick = (e) => {
        if (e.data?.id) {
            navigate(`/overtime/overtime-approval/${e.data.id}`);
        }
    };

    const handleApproveClick = (id) => {
        navigate(`/overtime/overtime-approval/${id}`);
    };

    useEffect(() => {
        if (setPublicAddEvent) {
            setPublicAddEvent(() => () => navigate("/overtime/overtime-card"));
        }
        return () => {
            if (setPublicAddEvent) {
                setPublicAddEvent(undefined);
            }
        };
    }, [setPublicAddEvent, navigate]);

    return (
        <LoaderPage loading={loading}>
            <div className="content-block">
                <div className="dx-card responsive-paddings">
                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        onRowDblClick={handleRowDblClick}
                        showBorders={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                        hoverStateEnabled={true}
                        keyExpr="id"
                        searchPanel={{ visible: true }}
                    >
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("Fazla Mesailer")}
                            <Item name="searchPanel" showText="always" />
                        </Toolbar>
                        <Column dataField="plug" caption="Fiş No" />
                        <Column dataField="employeeId" caption="Personel" >
                            <Lookup dataSource={dbEmployes} valueExpr="id" displayExpr="text" />
                        </Column>       
                                         <Column dataField="reason" caption="Açıklama" />
                        <Column dataField="location" caption="Mesai Konumu" />
                        <Column
                            dataField="startDate"
                            caption="Başlama Tarihi"
                            dataType="date"
                            format="dd.MM.yyyy"

                        />
                        <Column
                            dataField="endDate"
                            caption="Bitiş Tarihi"
                            dataType="date"
                            format="dd.MM.yyyy"

                        />

                        <Column
                            dataField="approvalStatus"
                            caption="Onay"

                        />
                        <Column
                            caption="İşlem"
                            cellRender={(cellData) => (
                                <div className="flex gap-2">
                                    <Button
                                        text="İncele"
                                        type="success"
                                        onClick={() => handleApproveClick(cellData.data.id)}
                                    />
                                </div>
                            )}
                        />
                        <Editing
                            allowDeleting={user?.permissions?.includes("DELETE_OVERTIME_REQUEST")}
                            allowUpdating={false}
                            useIcons={true}
                        />
                    </DataGrid>
                </div>
            </div>
        </LoaderPage>
    );
}

export default OvertimeList;